var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background",on:{"click":_vm.close}}),_c('div',{staticClass:"modal-content"},[_c('img',{staticClass:"centered-image",attrs:{"src":_vm.image}})]),_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close"},on:{"click":_vm.close}})])
}
var staticRenderFns = []

export { render, staticRenderFns }